import { render, staticRenderFns } from "./ingresoRegistro.vue?vue&type=template&id=700be860"
import script from "./ingresoRegistro.vue?vue&type=script&lang=js"
export * from "./ingresoRegistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports